import { project } from './geo.js';
/** Fiendtlig SIDC per deteksjonstype (samme som GNÅ-kartets _detectionSidc). */
export function detectionSidc(type) {
    switch (type) {
        case 'drone':
            return 'SHAPMFQ----';
        case 'gunshot':
            return 'SHGPEWR----';
        case 'artillery':
            return 'SHGPEWH----';
        case 'vehicle':
            return 'SHGPEV-----';
        case 'person':
            return 'SHGPUCI----';
        default:
            return 'SHGP-------';
    }
}
/**
 * SPARK sensor-event → 0–2 tracks: noden selv (vennlig sensor) og deteksjonens
 * kildepunkt (fiendtlig mål, løst eller projisert fra peiling). Identisk
 * to-modus-logikk som Rust/kart-siden.
 */
export function sensorEventToTracks(e) {
    const out = [];
    const ts = e.ts ?? 0;
    const nodeLat = e.pos?.lat;
    const nodeLon = e.pos?.lon;
    const alerting = e.kind === 'alarm' || e.kind === 'detection';
    // 1) Noden.
    if (nodeLat !== undefined && nodeLon !== undefined) {
        out.push({
            id: `spark:${e.node_id}`,
            kind: 'sensor',
            affiliation: 'friend',
            lat: nodeLat,
            lon: nodeLon,
            sidc: 'SFGPEWS----', // vennlig sensor
            label: `SPARK-${e.node_id}`,
            tsMs: ts,
            source: `spark:${e.node_id}`,
            extra: {
                ...(e.batt_pct !== undefined ? { batteri: `${e.batt_pct} %` } : {}),
                ...(e.mesh?.neighbors !== undefined ? { naboer: String(e.mesh.neighbors) } : {}),
                ...(e.mesh?.hops !== undefined ? { hopp: String(e.mesh.hops) } : {}),
                ...(e.mesh?.rssi_dbm !== undefined ? { rssi: `${Math.round(e.mesh.rssi_dbm)} dBm` } : {}),
            },
        });
    }
    // 2) Deteksjonens kildepunkt. Krev kind detection/alarm — SAMME gating som
    // GNÅ-kartet (_spotFor), så en payload med detection-blokk men annen kind
    // ikke tegnes ulikt i app vs. SKADE.
    const d = e.detection;
    // Egne skudd (#40, own=true) plottes ALDRI som fiendtlig mål — det er deg.
    if (d && alerting && d.own !== true) {
        let tLat = d.target?.lat;
        let tLon = d.target?.lon;
        let estimated = false;
        if ((tLat === undefined || tLon === undefined) &&
            nodeLat !== undefined && nodeLon !== undefined &&
            d.bearing_deg !== undefined && d.range_m !== undefined && d.range_m > 0) {
            const p = project({ lat: nodeLat, lon: nodeLon }, d.bearing_deg, d.range_m);
            tLat = p.lat;
            tLon = p.lon;
            estimated = true;
        }
        if (tLat !== undefined && tLon !== undefined) {
            out.push({
                // Stabil id per node+type (IKKE ts) → oppdaterer samme mål i stedet for
                // å samle én oppføring per måling; gir også breadcrumbs for mål.
                id: `tgt:${e.node_id}:${d.type ?? 'ukjent'}`,
                kind: 'detection',
                affiliation: 'hostile',
                lat: tLat,
                lon: tLon,
                sidc: detectionSidc(d.type),
                label: `MÅL ${(d.type ?? 'ukjent').toUpperCase()}`,
                tsMs: ts,
                cepM: estimated ? undefined : d.target?.cep_m,
                confidence: d.confidence,
                source: `spark:${e.node_id}`,
                estimated,
                extra: {
                    ...(d.count !== undefined ? { antall: String(d.count) } : {}),
                    ...(d.method ? { metode: d.method } : {}),
                    ...(estimated ? { modus: 'estimert (peiling)' } : { modus: 'løst punkt' }),
                },
            });
        }
    }
    return out;
}
//# sourceMappingURL=adapters.js.map